module.exports = __webpack_public_path__ + "media/loket-pendaftaran.6789ba7d.mp3";